import React, { useState, useRef } from 'react';
import {
  MenuItemLink,
  getResources,
  setSidebarVisibility,
  useRefresh,
  useVersion,
  usePermissions,
} from 'react-admin';
import { useSelector, useDispatch } from 'react-redux';

import { useMediaQuery } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import Fab from '@material-ui/core/Fab';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Zoom from '@material-ui/core/Zoom';
import AddIcon from '@material-ui/icons/Add';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import HomeIcon from '@material-ui/icons/Home';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';

import {
  DialogoTransacao,
  DialogoDespesaCartaoCredito,
} from '../../Components';
import { api } from '../../services';
import {
  SubMenuPessoal,
  SubMenuComprador,
  SubMenuVendas,
  SubMenuFiscal,
  SubMenuCompras,
  SubMenuProduto,
  SubMenuFinanceiro,
  SubMenuRelatorio,
  SubMenuGlobal,
  SubMenuContabilidade,
  SubMenuSistema,
  SubMenuTelevendas,
  SubMenuProcessos,
  SubMenuMalote,
  SubMenuEquipamentos,
  SubMenuDevelopment,
  SubMenuConferencias,
  SubMenuColetor,
  SubMenuDesenvolvedor,
  SubMenuLogistica,
} from './SubMenus';
import { getPermissoesDestrinchadas } from './utils/getPermissoes';

const useStyles = makeStyles((theme) => ({
  itemLogo: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: '15px',
    padding: '10px',
    paddingTop: 'px',
    marginBottom: '10px',
  },
  logo: {
    display: 'block',
    width: 'auto',
    height: '50px',
    backgroundColor: theme.palette.primary.main,
    padding: '5px',
    borderRadius: '5px',
  },
  content: {
    marginLeft: '5px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  icon: {
    color: theme.palette.primary.main,
  },
  activeIcon: {
    color: 'blue',
  },
  transacao: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: '#0039cb',
    backgroundColor: '#0039cb',
  },
  despesa: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: '#f44336',
    backgroundColor: '#f44336',
  },
  receita: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: '#4caf50',
    backgroundColor: '#4caf50',
  },
}));

const StyledMenuItemLink = withStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    '&:hover': {},
    marginLeft: '7px',
  },
  active: {
    borderLeft: '5px solid red',
    borderColor: '#00897B',
    backgroundColor: 'rgba(0, 138, 124, 0.15)',
    marginLeft: '2px',
  },
}))(MenuItemLink);

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    borderRadius: '20px',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {},
}))(MenuItem);

const TipoTransacaoSelect = ({ open, handleChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickItem = (code) => {
    handleClose();
    handleChange(code);
  };

  const dados = {
    color: '#0039cb',
    label: 'Transação',
  };

  return (
    <>
      <Fab
        variant={open ? 'extended' : 'circular'}
        style={{
          backgroundColor: 'white',
          color: dados.color,
          fontWeight: 'bold',
        }}
        onClick={(e) => {
          handleClick(e);
        }}
        size={open ? 'medium' : 'small'}
      >
        <AddIcon
          style={{
            color: dados.color,
            marginRight: open ? '5px' : '0px',
          }}
        />
        {open && <>{`Nova ${dados.label}`}</>}
      </Fab>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        TransitionComponent={Zoom}
        transitionDuration={500}
      >
        <StyledMenuItem onClick={() => handleClickItem('Despesa')}>
          <ListItemIcon>
            <TrendingDownIcon style={{ color: '#f44336' }} />
          </ListItemIcon>
          <ListItemText primary="Despesas" />
        </StyledMenuItem>
        <StyledMenuItem onClick={() => handleClickItem('Receita')}>
          <ListItemIcon>
            <TrendingUpIcon style={{ color: '#4caf50' }} />
          </ListItemIcon>
          <ListItemText primary="Receitas" />
        </StyledMenuItem>
        <StyledMenuItem onClick={() => handleClickItem('Transferência')}>
          <ListItemIcon>
            <AutorenewIcon style={{ color: '#0039cb' }} />
          </ListItemIcon>
          <ListItemText primary="Transferências" />
        </StyledMenuItem>
        <StyledMenuItem onClick={() => handleClickItem('Despesa_cartao')}>
          <ListItemIcon>
            <CreditCardIcon style={{ color: '#00796b' }} />
          </ListItemIcon>
          <ListItemText primary="Despesa cartão" />
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};

const MenuLocal = ({ onMenuClick, logout }) => {
  const classes = useStyles();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);
  const dispatch = useDispatch();
  const [open2, setOpen2] = useState(open);
  const refDialogoTransacao = useRef(null);
  const refDialogoDespesaCartao = useRef(null);
  const refresh = useRefresh();
  const version = useVersion();
  const [totalPendencias, setTotalPendencias] = useState(0);
  const [totalAnalise, setTotalAnalise] = useState(0);

  const { permissions: rawPermissoes } = usePermissions();
  const permissoes = rawPermissoes
    ? getPermissoesDestrinchadas(rawPermissoes)
    : {};

  const [menuOpen, setMenuOpen] = useState({
    menuPessoal: false,
    menuComprador: false,
    menuVendas: false,
    menuCompras: false,
    menuConfig: false,
    menuContabilidade: false,
    menuRelatorio: false,
    menuProduto: false,
    menuDevelopment: false,
    menuConferencia: false,
    menuContabilidadeEmpregos: false,
    menuEquipamentos: false,
    menuTelevendas: false,
    menuGlobal: false,
    menuInsumo: false,
    menuMalote: false,
    menuColetor: false,
    menuProcessos: false,
    menuDesenvolvedor: false,
    menuFiscal: false,
    menuLogistica: false,
  });

  React.useEffect(() => {
    if (open !== open2) dispatch(setSidebarVisibility(open2));
  }, [open2]);

  React.useEffect(() => {
    if (open !== open2) setOpen2(open);
  }, [open]);

  const handleToggle = (menuNome) => {
    setMenuOpen((state) => ({ ...state, [menuNome]: !state[menuNome] }));
  };

  function hasGetElement(resourceName) {
    for (let i = 0; i < resources.length; i += 1) {
      if (resources[i].name === resourceName) return resources[i];
    }
    return null;
  }

  function hasResource(resourceName, badge = 0) {
    const resource = hasGetElement(resourceName);
    const visible = resource ? resource.hasList : false;
    return visible ? (
      <StyledMenuItemLink
        key={resource.name}
        to={`/${resource.name}`}
        primaryText={resource.options.label}
        leftIcon={
          badge > 0 ? (
            <Badge badgeContent={badge} color="error">
              <resource.icon className={classes.icon} />
            </Badge>
          ) : (
            <resource.icon className={classes.icon} />
          )
        }
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    ) : null;
  }

  const create = (tipo) => {
    if (tipo === 'Despesa_cartao') {
      if (refDialogoDespesaCartao.current) {
        refDialogoDespesaCartao.current.handleCreate();
      }
    } else if (refDialogoTransacao.current) {
      refDialogoTransacao.current.handleCreate(tipo);
    }
  };

  const handleCloseDialogoTransacao = () => {
    refresh();
  };

  const {
    showVendas,
    showComprador,
    showCompras,
    showProduto,
    showFinanceiro,
    showRelatorio,
    showSistema,
    showContabilidade,
    showDevelopment,
    showConferencias,
    showTelevendas,
    showEquipamentos,
    showGlobal,
    showMalote,
    showColetor,
    showProcessos,
    showDesenvolvedor,
    showFiscal,
    showLogistica,
  } = permissoes;

  // Contagem do badge de "Minhas pendências"; o refresh feito ao assinar ou
  // enviar muda a `version` e atualiza o número. Falha não mostra badge.
  React.useEffect(() => {
    let ativo = true;

    function carregarPendencias() {
      api
        .get('/documentos/resumo')
        .then((response) => {
          if (!ativo) return;
          // Envios rejeitados ainda não vistos entram no badge (não no bloqueio).
          const {
            total,
            rejeitados,
            em_analise: emAnalise,
          } = response.data.data;
          setTotalPendencias(total + (rejeitados || 0));
          setTotalAnalise(emAnalise || 0);
        })
        .catch(() => {
          if (ativo) {
            setTotalPendencias(0);
            setTotalAnalise(0);
          }
        });
    }

    carregarPendencias();
    window.addEventListener('focus', carregarPendencias);

    return () => {
      ativo = false;
      window.removeEventListener('focus', carregarPendencias);
    };
  }, [version]);

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{ margin: '0px 0px 10px 10px' }}>
        {showFinanceiro ? (
          <TipoTransacaoSelect open={open} handleChange={create} />
        ) : null}
      </div>

      <StyledMenuItemLink
        key="inicio"
        to="/"
        exact
        primaryText="Início"
        leftIcon={<HomeIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />

      {/* Sempre visível: contém "Minhas pendências", aberta a todo usuário. */}
      <SubMenuPessoal
        classes={classes}
        open={open}
        onMenuClick={onMenuClick}
        isOpen={menuOpen.menuPessoal}
        handleToggle={() => handleToggle('menuPessoal')}
        hasResource={hasResource}
        permissoes={permissoes}
        totalPendencias={totalPendencias}
      />

      {showComprador && (
        <SubMenuComprador
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuComprador}
          handleToggle={() => handleToggle('menuComprador')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showVendas && (
        <SubMenuVendas
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuVendas}
          handleToggle={() => handleToggle('menuVendas')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showLogistica && (
        <SubMenuLogistica
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuLogistica}
          handleToggle={() => handleToggle('menuLogistica')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showFiscal && (
        <SubMenuFiscal
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuFiscal}
          handleToggle={() => handleToggle('menuFiscal')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showCompras && (
        <SubMenuCompras
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuCompras}
          handleToggle={() => handleToggle('menuCompras')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showProduto && (
        <SubMenuProduto
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuProduto}
          handleToggle={() => handleToggle('menuProduto')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showTelevendas && (
        <SubMenuTelevendas
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuTelevendas}
          handleToggle={() => handleToggle('menuTelevendas')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showProcessos && (
        <SubMenuProcessos
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuProcessos}
          handleToggle={() => handleToggle('menuProcessos')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showFinanceiro && (
        <SubMenuFinanceiro
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuContabilidade}
          handleToggle={() => handleToggle('menuContabilidade')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showMalote && (
        <SubMenuMalote
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuMalote}
          handleToggle={() => handleToggle('menuMalote')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showRelatorio && (
        <SubMenuRelatorio
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuRelatorio}
          handleToggle={() => handleToggle('menuRelatorio')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showGlobal && (
        <SubMenuGlobal
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuGlobal}
          handleToggle={() => handleToggle('menuGlobal')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showContabilidade && (
        <SubMenuContabilidade
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuContabilidadeEmpregos}
          handleToggle={() => handleToggle('menuContabilidadeEmpregos')}
          hasResource={hasResource}
          permissoes={permissoes}
          totalAnalise={totalAnalise}
        />
      )}

      {showEquipamentos && (
        <SubMenuEquipamentos
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuEquipamentos}
          handleToggle={() => handleToggle('menuEquipamentos')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showSistema && (
        <SubMenuSistema
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuConfig}
          handleToggle={() => handleToggle('menuConfig')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showDevelopment && (
        <SubMenuDevelopment
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuDevelopment}
          handleToggle={() => handleToggle('menuDevelopment')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showConferencias && (
        <SubMenuConferencias
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuConferencia}
          handleToggle={() => handleToggle('menuConferencia')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showColetor && (
        <SubMenuColetor
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuColetor}
          handleToggle={() => handleToggle('menuColetor')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {showDesenvolvedor && (
        <SubMenuDesenvolvedor
          classes={classes}
          open={open}
          onMenuClick={onMenuClick}
          isOpen={menuOpen.menuDesenvolvedor}
          handleToggle={() => handleToggle('menuDesenvolvedor')}
          hasResource={hasResource}
          permissoes={permissoes}
        />
      )}

      {isXSmall && logout}
      <DialogoTransacao
        ref={refDialogoTransacao}
        handleClose={handleCloseDialogoTransacao}
      />
      <DialogoDespesaCartaoCredito
        ref={refDialogoDespesaCartao}
        handleClose={handleCloseDialogoTransacao}
      />
    </div>
  );
};

export default MenuLocal;
